import styled from 'styled-components';

export const Container = styled.div`
	padding: 20px;
	width: 100%;
`;

export const ButtonContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 30px;
	justify-content: center;
	align-items: center;

	svg {
		padding-left: 10px;
	}
`;
